import { request } from '@services'

export const state = {
  loading: false,
  data: null,
  errors: null,
}

export const getters = {
  getFriendList(state) {
    return state.data
  },
}

export const mutations = {
  SET_FRIEND_LIST_REQUESTED(state) {
    state.loading = true
  },
  SET_FRIEND_LIST_RECEIVED(state, newData) {
    state.loading = false
    state.data = newData
    state.errors = null
  },
  SET_FRIEND_LIST_RECEIVED_FAILED(state, error) {
    state.loading = false
    state.errors = error
  },
  RESET_FRIEND_LIST(state) {
    state.loading = false
    state.data = null
    state.errors = null
  },
}

export const actions = {
  async fetchingFriendList({ commit }, params) {
    commit('SET_FRIEND_LIST_REQUESTED')
    try {
      const response = await request({
        endpoint: '/cms/friend/list/',
        payload: { ...params },
      })
      commit('SET_FRIEND_LIST_RECEIVED', response)
      return response
    } catch (error) {
      commit('SET_FRIEND_LIST_RECEIVED', error)
    }
  },
  resetAgentList({ commit }) {
    commit('RESET_FRIEND_LIST')
  },
}
